import { useRef } from 'react';
export function useRendersCount() {
    return ++useRef(0).current;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useRendersCount.js
// module id = ./node_modules/react-use/esm/useRendersCount.js
// module chunks = main